import AccessoryCommon from "./accessoryCommon";
// import DesignNavigationItem from "../../../../visComponents/designNavigationItem";

export default class ShowerPod extends AccessoryCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'shower_pod';
    this.partName = 'Shower Pod';
    this.translateId = "visualizer.bathroom.accessories.shower_pod";
    this.dbName = document.kvConfig.userId === 157639 ? 'Storage Pods' : 'Storage Pod'; // window.location.href.includes("american_standard_website")
    this.visible = true;
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    if (document.kvConfig.userId !== 157639 && dbFeature.groupName !== 'Storage Pod') {
      return false
    }
    return super.load_(dbFeature, new ShowerPod());
  }

  // navigationSubItems(filters, searchText) {
  //   const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
  //   const featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(), filteredAvailableFeatures);
  //   const parent = this.getParent();
  //   featuresToDisplay.forEach(feature => {
  //     if (parent.layout.parts.Window && parent.layout.parts.Window.windowKits && !parent.layout.parts.Window.windowKits.disabled) {
  //       feature.matchesMetaFailed = true;
  //     } else if (feature.matchesMetaFailed) {
  //       feature.matchesMetaFailed = false;
  //     }
  //   });
  //   return featuresToDisplay.map(_ => new DesignNavigationItem(_.featureName, _));
  // }

  // handleChangeParent(nonCompatibleWith) {
  //   if (nonCompatibleWith === "Window Kit") {
  //     const showerPodParent = this.getParent();
  //     const accessoriesParent = showerPodParent.getParent();
  //     accessoriesParent.layout.parts.Window.windowKits.disabled = true;
  //     showerPodParent.disabled = false;
  //     this.handleClick();
  //   }
  // }
  //
  // disabledClick() {
  //   const accessoriesParent = this.getParent();
  //   const windowParent = accessoriesParent.layout.parts.Window;
  //   if (windowParent && windowParent.windowKits && !windowParent.windowKits.disabled) {
  //     windowParent.windowKits.disabled = true;
  //   }
  // }

}
